import { render, staticRenderFns } from "./StockPrint2.vue?vue&type=template&id=3e854c74&scoped=true&"
import script from "./StockPrint2.vue?vue&type=script&lang=js&"
export * from "./StockPrint2.vue?vue&type=script&lang=js&"
import style0 from "./StockPrint2.vue?vue&type=style&index=0&id=3e854c74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e854c74",
  null
  
)

export default component.exports